import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';

export const useSettleCash = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number }) => tradesService.settleCash(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tradesKeys.all });
    },
  });
};
